module.exports = __webpack_public_path__ + "assets/img/Future_007.ef2b4dd2-ps.jpg";